import * as R from 'ramda'

class User {
    constructor({
        active = true,
        userId = 0,
        salutation = '',
        firstname = '',
        lastname = '',
        email = '',
        jobTitle = '',
        clientId = 0,
        role,
        langcode = 'en_GB',
        timezone = 'Europe/London',
        industryBenchmarkPrivilege = false,
        companyBenchmarkingPrivilege = false,
        divisionBenchmarkPrivileges = false,
        portfolioBenchmarkPrivilege = false,
        anonymizeReport = false,
        hideDistribute = false,
        isDashboardEnabled = true,
        allowPPT = 0,
        isDeliveryReportEnabled = false,
        isExploriAdmin = false,
        maincontact = false,
        useSSO = false,
        isExploriReseller = false,
    }) {
        this.userId = userId
        this.active = Boolean(active)
        this.clientId = clientId
        this.salutation = salutation
        this.firstName = firstname
        this.lastName = lastname
        this.email = email
        this.jobTitle = jobTitle
        this.roles = R.isNil(role)
            ? role
            : parseInt(role, 10)
        this.langcode = langcode
        this.timeZone = timezone
        this.industryBenchmarkPrivileges = Boolean(industryBenchmarkPrivilege)
        this.companyBenchmarkPrivileges = Boolean(companyBenchmarkingPrivilege)
        this.divisionBenchmarkPrivileges = Boolean(divisionBenchmarkPrivileges)
        this.portfolioBenchmarkPrivileges = Boolean(portfolioBenchmarkPrivilege)
        this.anonymizeReport = Boolean(anonymizeReport)
        this.hideDistribute = Boolean(hideDistribute)
        this.isDashboardEnabled = Boolean(isDashboardEnabled)
        this.allowPPT = Number(allowPPT)
        this.isDeliveryReportEnabled = Boolean(isDeliveryReportEnabled)
        this.isExploriAdmin = Boolean(isExploriAdmin)
        this.mainContact = Boolean(maincontact)
        this.useSSO = Boolean(useSSO)
        this.isExploriReseller = Boolean(isExploriReseller)

        this.sendLoginDetails = (this.userId === 0)
    }

    toJSON = (role = 0, isExploriAdmin = false) => {
        const commonJson = {
            active: this.active,
            salutation: this.salutation,
            firstName: this.firstName,
            lastname: this.lastName,
            email: this.email,
            jobtitle: this.jobTitle,
            roles: String(this.roles),
            langcode: this.langcode,
            timezone: this.timeZone,
            sendLoginDetails: this.sendLoginDetails,
        }

        const adminJson = {
            industryBenchmarkPrivileges: this.industryBenchmarkPrivileges,
            companyBenchmarkPrivileges: this.companyBenchmarkPrivileges,
            divisionBenchmarkPrivileges: this.divisionBenchmarkPrivileges,
            portfolioBenchmarkPrivileges: this.portfolioBenchmarkPrivileges,
            anonymizeReport: this.anonymizeReport,
            hideDistribute: this.hideDistribute,
            isDashboardEnabled: this.isDashboardEnabled,
            // maincontact: this.mainContact
        }

        let json = commonJson

        if (role < 120) {
            json = Object.assign(json, adminJson)
            if (isExploriAdmin) {
                json = Object.assign(json, {
                    allowPPT: this.allowPPT,
                    isDeliveryReportEnabled: this.isDeliveryReportEnabled,
                    useSSO: this.useSSO,
                    isExploriReseller: this.isExploriReseller,
                })
            }
        }

        return json
    }
}

export default User
